import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

function Main({ activeIndex }) {



    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>
                    <ListGroup>

                    <ListGroup.Item as={Link} action to="/Club_Committee_Members" className={`p-3 ${activeIndex==0 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Club Committee Members
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/cultural" className={`p-3 ${activeIndex==1 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Cultural
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/clubs" className={`p-3 ${activeIndex==2 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Clubs
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/219-sports-2" className={`p-3 ${activeIndex == 3 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Sports
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/220-social" className={`p-3 ${activeIndex == 4 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Social
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/festivals" className={`p-3 ${activeIndex == 5 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Festival
                        </ListGroup.Item>


                    </ListGroup>
                </Col>
                {/* <Col sm={8}>
          <Tab.Content>
            <Tab.Pane eventKey="#link1">Tab pane content 1</Tab.Pane>
            <Tab.Pane eventKey="#link2">Tab pane content 2</Tab.Pane>
          </Tab.Content>
        </Col> */}
            </Row>
        </Tab.Container>
    );
}

export default Main;